import { ExpandCircleDown } from "@mui/icons-material";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Grid,
} from "@mui/material";

export default function FaqSection() {
  return (
    <Grid container mt={3}>
      <Grid item xs={12}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandCircleDown sx={{ color: "comp3.main" }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography fontSize={20} fontWeight={700}>
              Frequently Asked Questions
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                paddingLeft: "25px",
                paddingRight: "25px",
                marginTop: "-10px",
              }}
            >
              <Typography
                variant="body1"
                fontWeight="bold"
                sx={{ marginBottom: "5px" }}
              >
                How do I reset my password?
              </Typography>
              On the Professional Portfolio login screen, click "Sign-In," and
              then click "Password Reset." When requested, enter your email
              address and click "Submit." You will receive an email with
              instructions on how to reset your password.
            </Typography>
            <Typography
              mt={3}
              sx={{
                backgroundColor: "#FFF4F0",
                paddingTop: "25px",
                paddingBottom: "25px",
                paddingLeft: "25px",
                paddingRight: "25px",
              }}
            >
              <Typography
                variant="body1"
                fontWeight="bold"
                sx={{ marginBottom: "5px" }}
              >
                Is there someone who can review my Reflective Statements of
                Competence and Professional Philosophy Statement?
              </Typography>
              No, the Council for Professional Recognition offers this
              Professional Portfolio application to make it easier for you to
              complete your portfolio, but we do not review what you put into
              the portfolio. We suggest you request your employer, trainer, a
              colleague, or your CDA Council Professional Development Specialist
              review your portfolio contents.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
}
